import React, { useState } from "react";

import { useTranslation } from "utils";

import { Checkbox, Flex, Icon, Popover, Typography } from "components";

type TimelineShowOptionsFilterProps = {
  showCropDetails?: boolean;
  onShowCropDetailsChange?: (checked: boolean) => void;
  showBaselineYears?: boolean;
  onShowBaselineYearsChange?: (checked: boolean) => void;
  showRecommendations?: boolean;
  onShowRecommendationsChange?: (checked: boolean) => void;
  isRecommendationsDisabled?: boolean;
};

export const TimelineShowOptionsFilter = ({
  showCropDetails,
  onShowCropDetailsChange,
  showBaselineYears,
  onShowBaselineYearsChange,
  showRecommendations,
  onShowRecommendationsChange,
  isRecommendationsDisabled,
}: TimelineShowOptionsFilterProps) => {
  const { t } = useTranslation(["fieldTimeline"]);
  const [isOpen, setIsOpen] = useState(false);
  const isActive = !!showCropDetails || !!showBaselineYears || !!showRecommendations;

  return (
    <Flex className={`field-filter-chip timeline-show-options-filter ${isActive ? "active" : ""}`}>
      <Popover
        open={isOpen}
        onOpenChange={setIsOpen}
        trigger="click"
        placement="bottomRight"
        className="filter-chip-popover timeline-show-options-filter-popover"
        content={
          <Flex vertical className="filter-chip-popover-content">
            {onShowCropDetailsChange && (
              <label className="filter-chip-option timeline-show-options-filter-option">
                <Checkbox checked={!!showCropDetails} onChange={(e) => onShowCropDetailsChange(e.target.checked)} />
                <Flex vertical gap="0.125rem">
                  <Typography variant="paragraph-m" className="margin-0">
                    {t("header.cropDetailsSwitchText")}
                  </Typography>
                  <Typography variant="paragraph-s" color="grey-600" className="margin-0">
                    {t("header.cropDetailsSwitchDescription")}
                  </Typography>
                </Flex>
              </label>
            )}
            {onShowBaselineYearsChange && (
              <label className="filter-chip-option timeline-show-options-filter-option">
                <Checkbox checked={!!showBaselineYears} onChange={(e) => onShowBaselineYearsChange(e.target.checked)} />
                <Flex vertical gap="0.125rem">
                  <Typography variant="paragraph-m" className="margin-0">
                    {t("header.baselineYearsSwitchText")}
                  </Typography>
                  <Typography variant="paragraph-s" color="grey-600" className="margin-0">
                    {t("header.baselineYearsSwitchDescription")}
                  </Typography>
                </Flex>
              </label>
            )}
            {onShowRecommendationsChange && (
              <label className="filter-chip-option timeline-show-options-filter-option">
                <Checkbox
                  checked={!!showRecommendations}
                  disabled={isRecommendationsDisabled}
                  onChange={(e) => onShowRecommendationsChange(e.target.checked)}
                />
                <Typography variant="paragraph-m" className="margin-0">
                  {t("header.recommendationSwitchText")}
                </Typography>
              </label>
            )}
          </Flex>
        }
      >
        <Flex className="field-filter-chip-trigger" align="center" gap="0.375rem" role="button" tabIndex={0}>
          <Icon iconName="tabler/eye" size="s" />
          <Typography variant="paragraph-m" noWrap className="margin-0">
            {t("header.showOptionsLabel")}
          </Typography>
          {isActive && <span className="timeline-show-options-filter-active-dot" />}
          <Icon iconName="tabler/chevron-down" size="s" />
        </Flex>
      </Popover>
    </Flex>
  );
};
